//自助點餐多語系：UI 字串字典與商品名稱語言 fallback
//商品的 english/japanese 由後台 translate:products 排程用 AI 補齊，缺日文顯示英文、缺英文顯示中文

export const KIOSK_LANGS = [
  {code: "zh", label: "中文"},
  {code: "en", label: "English"},
  {code: "ja", label: "日本語"},
];

export const DEFAULT_LANG = "zh";

//商品/類別/細項名稱：ja → en → zh 逐層 fallback
export const localizeName = (item, lang) => {
  if (!item) return "";
  if (lang === "ja") return item.japanese || item.english || item.name || "";
  if (lang === "en") return item.english || item.name || "";
  return item.name || "";
};

const STRINGS = {
  //通用
  back: {zh: "返回", en: "Back", ja: "戻る"},
  cancel: {zh: "取消", en: "Cancel", ja: "キャンセル"},
  confirm: {zh: "確認", en: "Confirm", ja: "確認"},
  apply: {zh: "套用", en: "Apply", ja: "適用"},
  dineIn: {zh: "內用", en: "Dine in", ja: "店内飲食"},
  takeout: {zh: "外帶", en: "Takeout", ja: "お持ち帰り"},
  offline: {zh: "網路中斷", en: "Offline", ja: "接続切断"},
  selfOrder: {zh: "自助點餐", en: "Self-Service Kiosk", ja: "セルフ注文"},
  itemsCount: {zh: "{n} 件", en: "{n} item(s)", ja: "{n}点"},

  //Header
  cartButton: {zh: "購物車（{n}）", en: "Cart ({n})", ja: "カート（{n}）"},
  endOrderTitle: {zh: "要結束這次點餐嗎？", en: "End this order?", ja: "注文を終了しますか？"},
  endOrderText: {zh: "已選的餐點會清空並回到首頁。", en: "Your selected items will be cleared and you'll return to the home screen.", ja: "選択した商品はクリアされ、ホーム画面に戻ります。"},
  goHome: {zh: "回首頁", en: "Back to home", ja: "ホームへ戻る"},
  keepOrdering: {zh: "繼續點餐", en: "Continue ordering", ja: "注文を続ける"},

  //Steps
  stepMenu: {zh: "選擇餐點", en: "Choose items", ja: "商品を選ぶ"},
  stepCart: {zh: "確認購物車", en: "Review cart", ja: "カート確認"},
  stepPay: {zh: "付款", en: "Payment", ja: "お支払い"},
  stepDone: {zh: "完成", en: "Done", ja: "完了"},

  //Welcome
  welcome: {zh: "歡迎光臨", en: "Welcome", ja: "いらっしゃいませ"},
  welcomeText: {zh: "輕觸開始，自在選擇今天想吃的餐點。", en: "Tap to start and pick whatever you feel like today.", ja: "タッチして、今日食べたいメニューをお選びください。"},
  counterPay: {zh: "櫃檯付款", en: "Pay at counter", ja: "レジで支払い"},
  startOrder: {zh: "開始點餐", en: "Start Order", ja: "注文を始める"},
  startOrderHint: {zh: "點選按鈕開始本次點餐", en: "Tap the button to begin", ja: "ボタンを押して注文を開始"},

  //ServiceMode
  chooseService: {zh: "請選擇用餐方式", en: "How would you like your meal?", ja: "お召し上がり方法をお選びください"},
  chooseServiceHint: {zh: "之後也可以在購物車中修改", en: "You can change this later in the cart", ja: "カートで後から変更できます"},
  dineInText: {zh: "在店內享用餐點", en: "Enjoy your meal in the restaurant", ja: "店内でお召し上がり"},
  takeoutText: {zh: "打包帶走，稍後享用", en: "Packed to go", ja: "お持ち帰りでどうぞ"},
  tableNumber: {zh: "桌號", en: "Table", ja: "テーブル番号"},
  tableChip: {zh: "{n} 桌", en: "Table {n}", ja: "テーブル{n}"},
  enterTableTitle: {zh: "請輸入桌號", en: "Enter your table number", ja: "テーブル番号を入力"},
  enterTableHint: {zh: "桌號在您座位的桌牌上", en: "You'll find it on the sign at your table", ja: "テーブルの札に番号があります"},
  keypadDelete: {zh: "刪除", en: "Delete", ja: "削除"},
  tableRequired: {zh: "請輸入桌號", en: "Please enter your table number", ja: "テーブル番号を入力してください"},

  //Menu
  categories: {zh: "商品分類", en: "Categories", ja: "カテゴリー"},
  meals: {zh: "餐點", en: "Menu", ja: "メニュー"},
  soldOutToday: {zh: "本日售完", en: "Sold out today", ja: "本日売り切れ"},
  pickedItems: {zh: "已選 {n} 件餐點", en: "{n} item(s) selected", ja: "{n}点選択中"},
  nextToCart: {zh: "下一步：確認購物車", en: "Next: Review cart", ja: "次へ：カートを確認"},

  //ProductCustomizer
  pickOne: {zh: "請選 1 項", en: "Pick 1", ja: "1つ選択"},
  adjustQty: {zh: "可調整數量", en: "Adjust quantity", ja: "数量調整可"},
  multiSelect: {zh: "可複選", en: "Multiple choices", ja: "複数選択可"},
  chooseOptions: {zh: "選擇規格", en: "Options", ja: "オプション"},
  required: {zh: "必選", en: "Required", ja: "必須"},
  optional: {zh: "非必選", en: "Optional", ja: "任意"},
  requiredHint: {zh: "尚未選擇", en: "Not chosen yet", ja: "未選択"},
  selectedCount: {zh: "已選 {n}", en: "{n} selected", ja: "{n}選択済"},
  pleaseChoose: {zh: "請選擇此項", en: "Please choose", ja: "選択してください"},
  comboDrink: {zh: "套餐飲品／湯品", en: "Combo drink / soup", ja: "セットドリンク／スープ"},
  comboDrinkGroup: {zh: "飲品", en: "Drinks", ja: "ドリンク"},
  comboSoupGroup: {zh: "湯品", en: "Soups", ja: "スープ"},
  noOptions: {zh: "此商品沒有其他規格，直接加入購物車即可。", en: "No extra options for this item — just add it to your cart.", ja: "この商品にはオプションがありません。そのままカートに追加できます。"},
  qtyAndNote: {zh: "數量與備註", en: "Quantity & note", ja: "数量とメモ"},
  itemNote: {zh: "餐點備註（非必選）", en: "Note (optional)", ja: "メモ（任意）"},
  missingRequired: {zh: "還有 {n} 項必選未完成", en: "{n} required option(s) left", ja: "必須項目があと{n}つあります"},
  saveChanges: {zh: "儲存修改", en: "Save changes", ja: "変更を保存"},
  addToCart: {zh: "加入購物車", en: "Add to cart", ja: "カートに追加"},
  decreaseQty: {zh: "減少數量", en: "Decrease quantity", ja: "数量を減らす"},
  increaseQty: {zh: "增加數量", en: "Increase quantity", ja: "数量を増やす"},

  //Cart
  reviewCart: {zh: "確認購物車", en: "Review your cart", ja: "カートを確認"},
  totalCount: {zh: "共 {n} 件", en: "{n} item(s) in total", ja: "合計{n}点"},
  emptyCart: {zh: "購物車還是空的", en: "Your cart is empty", ja: "カートは空です"},
  emptyCartText: {zh: "回到菜單挑選喜歡的餐點吧", en: "Head back to the menu and pick something you like", ja: "メニューに戻ってお好きな商品をお選びください"},
  startShopping: {zh: "開始選購", en: "Browse menu", ja: "メニューを見る"},
  notePrefix: {zh: "備註：", en: "Note: ", ja: "メモ："},
  editOptions: {zh: "編輯規格", en: "Edit options", ja: "オプション変更"},
  addMore: {zh: "＋ 繼續加點其他餐點", en: "＋ Add more items", ja: "＋ 他の商品を追加"},
  removeItem: {zh: "刪除{name}", en: "Remove {name}", ja: "{name}を削除"},
  wantPoints: {zh: "我要集點", en: "Earn member points", ja: "ポイントを貯める"},
  memberPointsHint: {zh: "輸入手機號碼累積點數", en: "Enter mobile number to earn points", ja: "携帯番号を入力してポイントを貯める"},
  pointsMobileLabel: {zh: "集點手機", en: "Points mobile", ja: "ポイント用携帯"},
  pickupMobileLabel: {zh: "取餐手機", en: "Pickup mobile", ja: "受け取り用携帯"},
  pickupMobileHint: {zh: "外帶以手機號碼作為取餐依據，同時累積會員點數", en: "We use your mobile number to identify your takeout order — it also earns member points", ja: "お持ち帰りは携帯番号でお渡しします。会員ポイントも貯まります"},
  notEntered: {zh: "尚未填寫", en: "Not set", ja: "未入力"},
  enterMobileTitle: {zh: "請輸入手機號碼", en: "Enter your mobile number", ja: "携帯番号を入力"},
  mobileRequired: {zh: "請輸入手機號碼才能結帳", en: "Enter your mobile number to continue", ja: "携帯番号を入力してください"},
  mobileFormatError: {zh: "請輸入 09 開頭共 10 碼", en: "Enter 10 digits starting with 09", ja: "09で始まる10桁を入力してください"},
  haveCoupon: {zh: "我有折扣碼", en: "I have a coupon", ja: "クーポンをお持ちの方"},
  coupon: {zh: "折扣碼", en: "Coupon", ja: "クーポン"},
  scanCoupon: {zh: "掃描優惠券 QR Code", en: "Scan coupon QR code", ja: "クーポンQRコードをスキャン"},
  couponInputHint: {zh: "或手動輸入折扣碼", en: "Or enter coupon code", ja: "またはコードを入力"},
  removeCoupon: {zh: "移除折扣碼", en: "Remove coupon", ja: "クーポンを削除"},
  couponNotFound: {zh: "查無此折扣碼", en: "Coupon not found", ja: "クーポンが見つかりません"},
  couponUnavailable: {zh: "此券{status}", en: "This coupon is not usable ({status})", ja: "このクーポンは利用できません（{status}）"},
  couponCheckFailed: {zh: "暫時無法確認折扣碼，請稍後再試", en: "Couldn't verify the coupon, please try again later", ja: "クーポンを確認できません。後でもう一度お試しください"},
  orderSummary: {zh: "訂單摘要", en: "Order summary", ja: "注文内容"},
  serviceMode: {zh: "用餐方式", en: "Service", ja: "お召し上がり方法"},
  edit: {zh: "修改", en: "Edit", ja: "変更"},
  mealCount: {zh: "餐點數量", en: "Items", ja: "商品数"},
  mealsSubtotal: {zh: "餐點金額", en: "Subtotal", ja: "小計"},
  discountDeduct: {zh: "優惠折抵", en: "Discount", ja: "割引"},
  comboDiscountTag: {zh: "套餐優惠", en: "Combo deal", ja: "セット割"},
  comboDiscountIncluded: {zh: "品項已含套餐優惠", en: "Combo deals included in item prices", ja: "商品価格にセット割を含む"},
  orderDiscountDeduct: {zh: "訂單優惠折抵", en: "Order discount", ja: "注文割引"},
  total: {zh: "合計", en: "Total", ja: "合計"},
  offlineCheckout: {zh: "網路中斷，連線恢復後才能結帳。", en: "Offline — checkout resumes once the connection is back.", ja: "接続が切れています。復旧後にお会計いただけます。"},
  nextToPayment: {zh: "下一步：選擇付款方式", en: "Next: Choose payment", ja: "次へ：支払い方法を選ぶ"},
  checkoutHint: {zh: "下一步將確認餐點與金額，尚未付款", en: "Items and total will be confirmed next — no payment yet", ja: "次のステップで内容と金額を確認します（まだ支払いは発生しません）"},
  cartChanged: {zh: "購物車內容已變更，請重新確認", en: "Your cart has changed, please review again", ja: "カートの内容が変わりました。もう一度ご確認ください"},
  quoteFailed: {zh: "暫時無法確認商品與價格，請檢查網路後再試一次。", en: "Couldn't confirm items and prices — check the connection and try again.", ja: "商品と価格を確認できません。接続を確認してもう一度お試しください。"},

  //Payment
  choosePayment: {zh: "選擇付款方式", en: "Choose payment method", ja: "お支払い方法を選択"},
  amountDue: {zh: "應付金額 ${n}", en: "Total due ${n}", ja: "お支払い金額 ${n}"},
  discountLine: {zh: "餐點 ${subtotal} － 折扣 ${discount}", en: "Subtotal ${subtotal} − Discount ${discount}", ja: "小計 ${subtotal} − 割引 ${discount}"},
  pointsMobile: {zh: "集點手機：{mobile}", en: "Points mobile: {mobile}", ja: "ポイント用携帯：{mobile}"},
  pickupMobileShown: {zh: "取餐手機：{mobile}", en: "Pickup mobile: {mobile}", ja: "受け取り用携帯：{mobile}"},
  linePayText: {zh: "出示手機付款碼，由本機掃描", en: "Show your payment code to the scanner", ja: "支払いコードを提示してスキャン"},
  counterCheckout: {zh: "櫃檯結帳", en: "Pay at counter", ja: "レジで支払い"},
  counterCheckoutText: {zh: "取得訂單編號後至櫃檯付款", en: "Get an order number and pay at the counter", ja: "注文番号を受け取りレジでお支払い"},
  createOrderFailed: {zh: "無法建立訂單，請返回購物車確認", en: "Couldn't create the order, please review your cart", ja: "注文を作成できません。カートをご確認ください"},
  createOrderNetworkError: {zh: "建立訂單時連線失敗，請勿重複操作；請按一次重試或洽店員協助。", en: "Connection failed while creating the order. Don't repeat the action — retry once or ask our staff.", ja: "注文作成中に接続に失敗しました。操作を繰り返さず、一度だけ再試行するかスタッフにお声がけください。"},

  //CounterPay（併入完成頁）
  orderNumber: {zh: "訂單號碼", en: "Order number", ja: "注文番号"},

  //LinePay
  scanLinePay: {zh: "掃描 Line Pay 付款碼", en: "Scan Line Pay payment code", ja: "Line Pay支払いコードをスキャン"},
  scanLinePayHint: {zh: "請在手機開啟 Line Pay 付款碼，對準機台背面鏡頭，畫面出現在左側白框內即可。", en: "Open your Line Pay payment code and hold it up to the rear camera so it appears inside the white frame.", ja: "Line Payの支払いコードを開き、本体背面のカメラにかざして左の白い枠内に映してください。"},
  payAmount: {zh: "應付 ${n}", en: "Amount due ${n}", ja: "お支払い ${n}"},
  paying: {zh: "付款處理中，請勿重複掃描", en: "Processing payment — please don't scan again", ja: "支払い処理中です。再スキャンしないでください"},
  manualCodeHint: {zh: "掃描槍無法使用時，可由店員輸入付款碼：", en: "If scanning fails, our staff can enter the code:", ja: "スキャンできない場合はスタッフがコードを入力します："},
  backToPayment: {zh: "尚未付款，返回選擇方式", en: "Not paid yet — choose another method", ja: "未払いのまま支払い方法へ戻る"},
  cameraDenied: {zh: "相機權限未開啟，請允許相機或使用掃描槍。", en: "Camera permission is off — allow the camera or use the scanner.", ja: "カメラが許可されていません。許可するかスキャナーをご利用ください。"},
  cameraUnavailable: {zh: "相機暫時無法使用，請使用掃描槍或洽店員。", en: "Camera unavailable — use the scanner or ask our staff.", ja: "カメラが使用できません。スキャナーを使うかスタッフにお声がけください。"},
  cameraStopped: {zh: "相機已中斷，請重新啟用相機再試。", en: "Camera stopped — re-enable it and try again.", ja: "カメラが停止しました。再起動してお試しください。"},
  cameraRetry: {zh: "重新啟用相機", en: "Re-enable camera", ja: "カメラを再起動"},
  invalidLineCode: {zh: "這不是 Line Pay 付款碼，請開啟 Line Pay 的付款條碼再試一次。", en: "That's not a Line Pay payment code. Open the barcode in Line Pay and try again.", ja: "Line Payの支払いコードではありません。Line Payのバーコードを開いてもう一度お試しください。"},
  payIncomplete: {zh: "付款未完成，請確認付款碼後再試一次。", en: "Payment incomplete — check the code and try again.", ja: "支払いが完了していません。コードを確認してもう一度お試しください。"},
  payChecking: {zh: "付款結果確認中，請勿重新付款…", en: "Confirming payment — please don't pay again…", ja: "支払い結果を確認中です。再度支払わないでください…"},
  payUnconfirmed: {zh: "目前尚未確認付款成功，請洽店員協助，請勿重複掃描。", en: "Payment isn't confirmed yet — please ask our staff and don't scan again.", ja: "支払いが確認できていません。スタッフにお声がけください。再スキャンはしないでください。"},
  payNetworkError: {zh: "網路中斷，無法確認付款結果。請勿重複付款，請洽店員協助。", en: "Connection lost — payment result unknown. Don't pay again, please ask our staff.", ja: "接続が切れ、支払い結果を確認できません。再度支払わず、スタッフにお声がけください。"},
  payRecovered: {zh: "已恢復未完成的訂單，確認未付款後才能重新掃描。", en: "Recovered an unfinished order — verify it's unpaid before scanning again.", ja: "未完了の注文を復元しました。未払いを確認してから再スキャンしてください。"},
  payRecoverFailed: {zh: "無法確認先前付款結果，請勿重複付款並洽店員協助。", en: "Couldn't confirm the previous payment. Don't pay again — ask our staff.", ja: "前回の支払い結果を確認できません。再度支払わず、スタッフにお声がけください。"},

  //Complete
  orderCreated: {zh: "訂單已建立，請至櫃檯結帳", en: "Order placed — please pay at the counter", ja: "ご注文を受け付けました。レジでお支払いください"},
  paySuccess: {zh: "付款成功", en: "Payment successful", ja: "お支払い完了"},
  orderCreatedText: {zh: "請向店員說出下方號碼完成付款，餐點已開始製作", en: "Tell our staff the number below to pay — your meal is already being prepared", ja: "スタッフに下の番号をお伝えください。調理はすでに始まっています"},
  paySuccessText: {zh: "餐點已送出，請留意叫號", en: "Your order is in — listen for your number", ja: "ご注文を承りました。番号のお呼び出しをお待ちください"},
  doneCountdown: {zh: "完成（{n}）", en: "Done ({n})", ja: "完了（{n}）"},

  //Idle
  idleTitle: {zh: "還要繼續點餐嗎？", en: "Still ordering?", ja: "注文を続けますか？"},
  idleText: {zh: "為保護您的資料，{n} 秒後會取消本次操作。", en: "To protect your info, this session ends in {n} seconds.", ja: "情報保護のため、{n}秒後に操作をキャンセルします。"},
  idleCancel: {zh: "取消點餐", en: "Cancel order", ja: "注文をやめる"},

  //Coupon scan dialog
  scanCouponTitle: {zh: "掃描折扣碼", en: "Scan coupon", ja: "クーポンをスキャン"},
  scanCouponHint: {zh: "請把手機上的優惠券 QR Code 對準鏡頭", en: "Hold your coupon QR code up to the camera", ja: "クーポンのQRコードをカメラにかざしてください"},
  scanNotSupported: {zh: "此裝置不支援掃描，請改用輸入折扣碼。", en: "Scanning isn't supported here — enter the code instead.", ja: "この端末はスキャンに対応していません。コードを入力してください。"},
  scanCameraDenied: {zh: "相機權限未開啟，請允許相機或改用輸入折扣碼。", en: "Camera permission is off — allow it or enter the code instead.", ja: "カメラが許可されていません。許可するかコードを入力してください。"},
  scanCameraUnavailable: {zh: "相機暫時無法使用，請改用輸入折扣碼。", en: "Camera unavailable — enter the code instead.", ja: "カメラが使用できません。コードを入力してください。"},
};

//t("ja", "cartButton", {n: 3}) → "カート（3）"
export const t = (lang, key, params) => {
  const entry = STRINGS[key];
  if (!entry) return key;
  let text = entry[lang] ?? entry.zh ?? key;
  if (params) {
    Object.entries(params).forEach(([name, value]) => {
      text = text.replaceAll(`{${name}}`, String(value));
    });
  }
  return text;
};
